import { render, staticRenderFns } from "./DeliveryForm.vue?vue&type=template&id=1b366b15&scoped=true"
import script from "./DeliveryForm.vue?vue&type=script&lang=js"
export * from "./DeliveryForm.vue?vue&type=script&lang=js"
import style0 from "./DeliveryForm.vue?vue&type=style&index=0&id=1b366b15&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b366b15",
  null
  
)

export default component.exports